module.exports = __webpack_public_path__ + "static/img/stay-option-icon-soccer.a9b99ac9.svg";